import endpoints from "../../../functions/databaseEndpoints";
export async function getCountryStateList(countryId) {
   const mainEndpoint = `${endpoints.PUBLIC_ENDPOINT}getCountryStateList`;
   try {
      const rawResponse = await fetch(mainEndpoint, {
         method: "POST",
         headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
         },
         body: JSON.stringify({
            countryId,
         }),
      });
      const content = await rawResponse.json();
      return content;
   } catch (e) {
      alert(e.message);
   }
}
